import { ColDef } from '@ag-grid-enterprise/all-modules'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ConfigurationIntermediateShelfSampleProcessAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.dto'
import { configurationIntermediateShelfSampleProcessAssignmentService } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefAutomationGrossingShelfIntermediateShelfProcessGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.intermediateShelfProcess'),
            field: 'sampleProcess.name',
            minWidth: 400,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        }
    ]

export interface ConfigurationAutomationGrossingShelfIntermediateShelfProcessGridState extends CrudModelPaginatorLaboratory<ConfigurationIntermediateShelfSampleProcessAssignmentResponse> {
    service: typeof configurationIntermediateShelfSampleProcessAssignmentService
    laboratoryId: number
}
export const initialConfigurationAutomationGrossingShelfIntermediateShelfProcessGridState =
    (): ConfigurationAutomationGrossingShelfIntermediateShelfProcessGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.grossingShelf.intermediateShelfProcess',
        columnsDef: columnsDefAutomationGrossingShelfIntermediateShelfProcessGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationIntermediateShelfSampleProcessAssignmentService, store.getters.labId),
        service: configurationIntermediateShelfSampleProcessAssignmentService,
        laboratoryId: store.getters.labId
    })
